class areasNavigationController {
    constructor($state, $stateParams, learningAreaService) {

        learningAreaService.list()
            .then(res => { this.defaultTabs = res; })
            .catch(err => console.log('ERROR', err));

        this.isCurrentGoal = function(subjectAreaId) {
            if (subjectAreaId) {
                return subjectAreaId === +$stateParams.subjectAreaId;
            } else {
                return $state.current.name === $state.$current.parent.self.name + '.subjectArea';
            }
        };

        this.gotoFirstTab = () => {
            $state.go('^.subjectArea');
        };
        this.gotoTab = (subAreaId) => {
            $state.go('^.defaultSubjectArea', {subjectAreaId: subAreaId});
        };
    }
}

areasNavigationController.$inject = [
    '$state',
    '$stateParams',
    'LearningAreaService',
];

export default areasNavigationController;


// WEBPACK FOOTER //
// ./src/app/pages/evaluation/components/areasNavigation/areasNavigationController.js